var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.6875 1.75C2.96439 1.75 1.5 3.23565 1.5 5.15385V13.4615C1.5 16.1444 3.55201 18.25 6 18.25C8.448 18.25 10.5 16.1444 10.5 13.4615V5.15385H12V13.4615C12 16.8963 9.351 19.75 6 19.75C2.649 19.75 0 16.8963 0 13.4615V5.15385C0 2.48383 2.06137 0.25 4.6875 0.25C7.3136 0.25 9.375 2.48383 9.375 5.15385V13.4615C9.375 15.3669 7.9013 16.9808 6 16.9808C4.0987 16.9808 2.625 15.3669 2.625 13.4615V5.15385H4.125V13.4615C4.125 14.615 5.0018 15.4808 6 15.4808C6.9982 15.4808 7.875 14.615 7.875 13.4615V5.15385C7.875 3.23565 6.4106 1.75 4.6875 1.75Z",
    fill: "#5B5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.18a4a4c91d237fb90cfde6d2b9a7b715.svg";
export { ForwardRef as ReactComponent };